import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDZkE8pWI6ZEkopbPkTUUh2mBimgOCqq-c",
  authDomain: "participace-21-map.firebaseapp.com",
  databaseURL: "https://participace-21-map.firebaseio.com",
  projectId: "participace-21-map",
  storageBucket: "participace-21-map.appspot.com",
  messagingSenderId: "1099136547795",
  appId: "1:1099136547795:web:d0ecfa796916881addcd26",
};

const fire = firebase.initializeApp(firebaseConfig);

export default fire;
ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
